export default __webpack_public_path__ + "static/media/69.c6af0839.png";